import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";

function OkPopup(props) {
  return (
    <Dialog open={true}>
      <DialogTitle>{props.titletext}</DialogTitle>
      <DialogContent>
        <p>{props.text}</p>
        <div className="acquisti_popup_button" onClick={props.closeHandler}>
          OK
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default OkPopup;
